// src/hooks/useVideosLanding.ts

import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabaseClient';

export interface VideoLanding {
  id_video: string;
  titulo: string;
  descripcion: string;
  youtube_embed: string;
}

const useVideosLanding = () => {
  const [videos, setVideos] = useState<VideoLanding[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    supabase
      .from('videos_landing')
      .select('id_video, titulo, descripcion, youtube_embed')
      .eq('activo', true)
      .order('orden')
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setVideos(data ?? []);
        setLoading(false);
      });
  }, []);

  return { videos, loading, error };
};

export default useVideosLanding;
